import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getOrders = async () => {
    const response = await axios.get(routes.ordersList, AXIOS_DEFAULT_CONFIG);
    return response;
};
export default getOrders;
